import axios from 'axios';

const envBase = (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE)?.replace(/\/$/, '');
const defaultHost = typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.hostname}:5000` : '';
const baseHost = envBase || defaultHost;
const baseURL = baseHost ? `${baseHost.replace(/\/$/, '')}/api` : '/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
